var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"classic submain-div"}},[_c('div',[_c('h1',[_vm._v("奇思百货系统")]),_c('p',[_vm._v("调试中 目前拥有将近5000左右的百货数据")]),_c('p',{staticStyle:{"color":"red","font-size":"30px"}},[_vm._v("暂未上市")])]),_c('div',[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/img/store/store1.png"),"alt":""}})])])
}]

export { render, staticRenderFns }